export const ADD_CONTENT_GENERATION_DATA: string =
  'ADD_CONTENT_GENERATION_DATA';
export const SET_CONTENT_GENERATION_DATA: string =
  'SET_CONTENT_GENERATION_DATA';
export const RESET_CONTENT_GENERATION_DATA: string =
  'RESET_CONTENT_GENERATION_DATA';
export const DELETE_CONTENT_GENERATION_DATA: string =
  'DELETE_CONTENT_GENERATION_DATA';
